import {getCurrentYear} from '../../utils/commons'
import TopOutdoorProductReviewsLogo from './logo'
import {topOutdoorProductReviewsCA, topOutdoorProductReviewsUK} from './styles'

const baseConfig = {
  domainName: 'topoutdoorproductreviews' as const,
  siteName: 'Top Outdoor Product Reviews',
  favicon: '/favicons/topoutdoorproductreviews.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-W9Q5H6YPTP',
    domainType: 'eu' as const,
    camelCaseUrl: 'TopOutdoorProductReviews.co.uk',
    logo: <TopOutdoorProductReviewsLogo className="size-9 shrink-0 tablet:size-7 mobile:size-6" locale="uk" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in the UK | TopOutdoorProductReviews.co.uk – Detailed Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `At TopOutdoorProductReviews.co.uk, we handpicked the best ranked outdoor products for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart shopping choices`,
    styles: topOutdoorProductReviewsUK,
  },
  ca: {
    measurementId: 'G-G48PG448LF',
    domainType: 'picks' as const,
    camelCaseUrl: 'TopOutdoorProductReviews.ca',
    logo: <TopOutdoorProductReviewsLogo className="size-9 shrink-0 tablet:size-7 mobile:size-6" locale="ca" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in CA | TopOutdoorProductReviews.ca – Detailed Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `At TopOutdoorProductReviews.ca, we handpicked the best ranked outdoor products for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart shopping choices.`,
    styles: topOutdoorProductReviewsCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
